<template>
    <div class="animated fadeIn">
        <b-alert show variant="danger" >
            Доделать фильтры
        </b-alert>
        <b-card>
            <b-row>
            <b-col md="6">

<!--                <b-form-group label="Дата брони: " :label-cols="3" :horizontal="false">-->
<!--                    <div class="input-group">-->
<!--                        <v-date-picker-->
<!--                            id="rangeCRSelect"-->
<!--                            mode='range'-->
<!--                            v-model='rangeCRFilter'-->
<!--                            @change="applyRangeCRFilter()"-->
<!--                            @input="applyRangeCRFilter()"-->
<!--                            :attributes="datepicker_attributes"-->
<!--                        >-->
<!--                            <b-form-input-->
<!--                                type="text"-->
<!--                                id="rangeCRSelect_input"-->
<!--                                slot-scope="{ inputProps, inputEvents, isDragging }"-->
<!--                                class="form-control form-date-picker"-->
<!--                                readonly-->
<!--                                v-bind="inputProps"-->
<!--                                v-on="inputEvents" />-->
<!--                        </v-date-picker>-->
<!--                        <b-button type="button" variant="secondary"  @click='resetRangeCRFilter()'><i class="cui-circle-x icon"></i> </b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

<!--                <b-form-group label="Дата заезда: " :label-cols="3" :horizontal="false">-->
<!--                    <div class="input-group">-->
<!--                        <v-date-picker-->
<!--                            id="rangeCISelect"-->
<!--                            mode='range'-->
<!--                            v-model='rangeCIFilter'-->
<!--                            @change="applyRangeCIFilter()"-->
<!--                            @input="applyRangeCIFilter()"-->
<!--                            :attributes="datepicker_attributes"-->
<!--                        > <b-form-input-->
<!--                            type="text"-->
<!--                            id="rangeCISelect_input"-->
<!--                            slot-scope="{ inputProps, inputEvents, isDragging }"-->
<!--                            class="form-control form-date-picker"-->
<!--                            readonly-->
<!--                            v-bind="inputProps"-->
<!--                            v-on="inputEvents" />-->
<!--                        </v-date-picker>-->
<!--                        <b-button type="button" variant="secondary"  @click='resetRangeCIFilter()'><i class="cui-circle-x icon"></i> </b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

<!--                <b-form-group label="Дата выезда: " label-for="rangeSelect" :label-cols="3" :horizontal="false">-->
<!--                    <div class="input-group">-->
<!--                        <v-date-picker-->
<!--                            id="rangeCOSelect"-->
<!--                            mode='range'-->
<!--                            v-model='rangeCOFilter'-->
<!--                            @change="applyRangeCOFilter()"-->
<!--                            @input="applyRangeCOFilter()"-->
<!--                            :attributes="datepicker_attributes"-->
<!--                        >-->

<!--                            <b-form-input-->
<!--                                type="text"-->
<!--                                id="rangeSelect_input"-->
<!--                                slot-scope="{ inputProps, inputEvents, isDragging }"-->
<!--                                class="form-control form-date-picker"-->
<!--                                readonly-->
<!--                                v-bind="inputProps"-->
<!--                                v-on="inputEvents" />-->
<!--                        </v-date-picker>-->
<!--                        <b-button type="button" variant="secondary"  @click='resetRangeCOFilter()'><i class="cui-circle-x icon"></i> </b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

<!--                <b-form-group label="Дата счета объекта: " label-for="rangeSelect" :label-cols="3" :horizontal="false">-->
<!--                    <div class="input-group">-->
<!--                        <v-date-picker-->
<!--                            id="rangeCOSelect"-->
<!--                            mode='range'-->
<!--                            v-model='rangeCOFilter'-->
<!--                            @change="applyRangeCOFilter()"-->
<!--                            @input="applyRangeCOFilter()"-->
<!--                            :attributes="datepicker_attributes"-->
<!--                        >-->

<!--                            <b-form-input-->
<!--                                type="text"-->
<!--                                id="rangeSelect_input"-->
<!--                                slot-scope="{ inputProps, inputEvents, isDragging }"-->
<!--                                class="form-control form-date-picker"-->
<!--                                readonly-->
<!--                                v-bind="inputProps"-->
<!--                                v-on="inputEvents" />-->
<!--                        </v-date-picker>-->
<!--                        <b-button type="button" variant="secondary"  @click='resetRangeCOFilter()'><i class="cui-circle-x icon"></i> </b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

                <b-form-group label="Статус брони: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                    <v-select
                        v-model="booking_state_filter"
                        :options="CONSTANTS.BOOKING_STATUS_NAMES"
                        placeholder="Статус брони"
                        label="title"
                        :reduce="x=>x.id"
                        @input="applyStatusFilter"
                    ></v-select>
                </b-form-group>


                <b-form-group label="Вид брони: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                    <v-select
                        v-model="booking_type_filter"
                        :options="CONSTANTS.BOOKING_TYPES_NAMES"
                        placeholder="Вид брони"
                        label="title"
                        :reduce="x=>x.id"
                        @input="applyTypeFilter"
                    ></v-select>
                </b-form-group>


                <b-form-group label="Без получателя" :label-cols="3" :horizontal="false" description="показывать только брони у которых не указан получатель">
                    <div class="custom-control custom-checkbox custom-control-inline" @change='noSupplierChanged()'>
                        <input type="checkbox" class="custom-control-input" id="no_sipplier_filter" value="1" v-model="no_sipplier_filter">
                        <label class="custom-control-label" for="no_sipplier_filter">только брони без получателя</label>
                    </div>
                </b-form-group>


            </b-col>
            <b-col md="6">



<!--                <b-form-group label="Агентство: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">-->
<!--                    <div class="input-group">-->
<!--                        <b-form-select id="basicSelect"-->
<!--                                       @change="applyCompanyFilter()"-->
<!--                                       :plain="true"-->
<!--                                       v-model="companyFilter"-->
<!--                                       :options="getMainCompanies()"-->
<!--                                       value-field="id"-->
<!--                                       text-field="title"-->
<!--                                       value="Please select">-->
<!--                        </b-form-select>-->
<!--                        <b-button type="button" variant="secondary" @click="resetCompanyFilter()"> <i class="cui-circle-x icon "></i></b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

<!--                <b-form-group label="Юр/лицо агентства: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">-->
<!--                    <div class="input-group">-->
<!--                        <b-form-select id="basicSelect"-->
<!--                                       @change="applyDocCompanyFilter() "-->
<!--                                       :plain="true"-->
<!--                                       v-model="docCompanyFilter"-->
<!--                                       :options="getDocCompanies()"-->
<!--                                       value-field="id"-->
<!--                                       text-field="title"-->
<!--                                       value="Please select">-->
<!--                        </b-form-select>-->
<!--                        <b-button type="button" variant="secondary" @click="resetDocCompanyFilter()"> <i class="cui-circle-x icon "></i></b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

<!--                <b-form-group label="Агент: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">-->
<!--                    <div class="input-group">-->
<!--                        <b-form-select id="basicSelect"-->
<!--                                       @change="applyUserFilter() "-->
<!--                                       :plain="true"-->
<!--                                       v-model="userFilter"-->
<!--                                       :options="getUsers()"-->
<!--                                       value-field="id"-->
<!--                                       text-field="full_name"-->
<!--                                       value="Please select">-->
<!--                        </b-form-select>-->
<!--                        <b-button type="button" variant="secondary" @click="resetUserFilter()"> <i class="cui-circle-x icon "></i></b-button>-->
<!--                    </div>-->
<!--                </b-form-group>-->

                <b-form-group label="Объект: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                    <v-select
                        v-model="hotel_filter"
                        :options="_hotels"
                        placeholder="Объект размещения"
                        label="title_decorated"
                        :reduce="x=>x.id"
                        @input="applyHotelFilter"
                    ></v-select>
                </b-form-group>

                <b-form-group label="Поставщик: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                    <v-select
                        v-model="hotel_company_filter"
                        :options="_hotelCompanies"
                        placeholder="Компания поставщик"
                        label="title"
                        :reduce="x=>x.id"
                        @input="applyHotelCompanyFilter"
                    ></v-select>
                </b-form-group>

            </b-col>
        </b-row>
            <v-server-table :url="apiurl('booking/table')"  :columns="columns" :options="options" :theme="theme" id="bookingsTable" ref="bookingsTable"  >
            <span slot="id" slot-scope="props">
                <a :href="$router.resolve({ path:bookingPage(props.row.id)}).href">{{props.row.id}}</a><small><br>
                {{ getBookingStatusName(props.row.status) }}
                </small>
            </span>
            <span slot="voucher_id" slot-scope="props">
                <a :href="$router.resolve({ path:voucherPage(props.row.voucher_id)}).href">{{ props.row.voucher_id }}</a><small><br>
                {{ getVoucherStatusName(props.row.voucher.status_index) }}
                </small>
            </span>
            <span slot="voucher.hotel.title" slot-scope="props">
                <strong>{{props.row.voucher.hotel.title}}</strong><small><br>
                {{props.row.voucher.city.title}}<br>
                {{props.row.company.title}}</small>
            </span>

            <span slot="start_at" slot-scope="props">
                <strong>{{printDate(props.row.start_at)}}</strong><br>
                {{printDate(props.row.end_at)}}<br>
            </span>

            <span slot="type" slot-scope="props">
                <template v-if="props.row.prebook">
                    предварительная бронь до {{printDate(props.row.wait_invoice_date)}}
                </template>
                <template v-else-if="props.row.direct_payment">
                    прямая оплата в объект
                </template>
                <template v-else-if="props.row.wait_invoice_date">
                    ожидаем поступление счета до {{printDate(props.row.wait_invoice_date)}}
                </template>
                <template v-else>
                    оплатить до {{printDate(props.row.redemption_date)}}
                </template>
            </span>

            <span slot="invoice_number" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment && !props.row.wait_invoice_date" >
                    № {{props.row.invoice_number}}<br>
                    {{printDate(props.row.invoice_date)}}
                </template>
            </span>

            <span slot="invoice_value" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment" >
                    {{ formatPriceKop(props.row.invoice_value) }}
                </template>
            </span>
            <span slot="to_pay_value" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment && !props.row.wait_invoice_date" >
                    {{ formatPriceKop(props.row.to_pay_value) }}
                </template>
            </span>

            <span slot="redemption_date" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment && !props.row.wait_invoice_date" >
                    {{printDate(props.row.redemption_date)}}
                </template>
            </span>

            <span slot="bill_number" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment" >
                    № {{props.row.bill_number}}<br>
                    {{printDate(props.row.bill_date)}}
                </template>
            </span>

            <span slot="bill_value" slot-scope="props">
                <template v-if="!props.row.prebook && !props.row.direct_payment" >
                    {{ formatPriceKop(props.row.bill_value) }}
                </template>
            </span>
        </v-server-table>
        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import {CONSTANTS} from '@/constants';
    import id from '../jsx/bookings/id'
    import type from '../jsx/bookings/type'
    import { functions_booking } from '@/functions/booking.js';
    import { functions_voucher } from '@/functions_voucher.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_hotel   } from '@/functions/hotel.js';

    Vue.use(ServerTable)

    export default {
        name: 'NsbManagerBookings',
        components: { ServerTable, Event },
        mixins: [functions, functions_booking, functions_voucher, functions_company, functions_hotel ],
        data: function () {
            return {
                columns:['id', 'voucher_id', 'voucher.hotel.title', 'start_at', 'type', 'invoice_number', 'invoice_value', 'to_pay_value', 'redemption_date', 'bill_number', 'bill_value'],
                options: {
                    saveState: true,
                    headings: {
                        id: 'ID',
                        voucher_id: 'Путевка',
                        'voucher.hotel.title': 'Объект/Город/Агентство',
                        start_at: 'Заезд/Выезд',
                        type: 'вид брони',
                        invoice_number: 'Счет',
                        invoice_date: 'Дата счета',
                        invoice_value: 'Сумма счета от объекта',
                        to_pay_value: 'Сумма к оплате в объект',
                        redemption_date: 'Крайняя дата оплаты',

                        bill_number: 'Cчет агентству',
                        bill_value: 'Сумма счета агентству',

                        date_end_iso: 'даты',
                        contact_name: 'заказчик/объект размещения',
                        company_and_user: 'агентство',
                        status_index: 'Статус',
                        'voucher.city.title': 'Город',
                        'company.title': 'Агентство',

                    },
                    templates: {},
                    sortable: [ 'id', 'voucher_id'],
                    dateColumns:[],
                    filterable: ['id', 'voucher_id', 'contact_name', 'summa_full', 'summa_fact_payment', 'invoice_number', 'bill_number' ],
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    customFilters: [
                        'hotel',
                        'hotel_company',
                        'status',
                        'type',
                        'no_supplier',
                    ],
                    perPageValues:[],

                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                template: 'default',

                hotel_filter: null,
                hotel_company_filter: null,
                booking_state_filter:null,
                booking_type_filter:null,
                no_sipplier_filter:false,

            }
        },
        methods: {
            applyHotelFilter:function(){
                this.saveFilter();
                Event.$emit('vue-tables.filter::hotel', this.hotel_filter);
            },

            applyHotelCompanyFilter:function(){
                console.log('applyHotelCompanyFilter')
                this.saveFilter();
                Event.$emit('vue-tables.filter::hotel_company', this.hotel_company_filter);
            },

            applyStatusFilter:function(){
                console.log('applyStatusFilter')
                this.saveFilter();
                Event.$emit('vue-tables.filter::status', this.booking_state_filter);
            },

            applyTypeFilter:function(){
                console.log('applyTypeFilter')
                this.saveFilter();
                Event.$emit('vue-tables.filter::type', this.booking_type_filter);
            },

            saveFilter: function () {
                console.log('saveFilter')
                this.$store.commit('saveBookingFilters', {
                    hotel_filter: this.hotel_filter,
                    hotel_company_filter: this.hotel_company_filter,
                    booking_state_filter: this.booking_state_filter,
                    booking_type_filter: this.booking_type_filter,
                    no_sipplier_filter: this.no_sipplier_filter,
                });
            },

            restoreFilter: function () {
                this.booking_state_filter = this.$store.state.bookingFilters.booking_state_filter;
                if (this.booking_state_filter === CONSTANTS.BOOKING_STATUS_UNKNOWN) this.booking_state_filter=null;

                this.booking_type_filter = this.$store.state.bookingFilters.booking_type_filter;
                if (!this.booking_type_filter) this.booking_type_filter=null;

                this.hotel_filter = this.$store.state.bookingFilters.hotel_filter;
                if (!this.hotel_filter) this.hotel_filter=null;

                this.hotel_company_filter = this.$store.state.bookingFilters.hotel_company_filter;
                if (!this.hotel_company_filter) this.hotel_company_filter=null;

                this.no_sipplier_filter = this.$store.state.bookingFilters.no_sipplier_filter;
                if (!this.no_sipplier_filter) this.no_sipplier_filter=null;
            },

            noSupplierChanged: function () {
                console.log('noSupplierChanged')
                this.saveFilter();
                Event.$emit('vue-tables.filter::no_supplier', this.no_sipplier_filter);
            },

        },
        computed: {
            _hotels: function () {
                return this.hotels;
            },
            _hotelCompanies: function () {
                return this.companies.filter((c) => c.type & CONSTANTS.COMPANY_TYPE_HOTEL  );
            },
            _agentCompanies: function () {
                return this.companies.filter((c) => c.type & CONSTANTS.COMPANY_TYPE_AGENCY  );
            },
        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
            this.loadCompanies();
            this.loadHotels();
        }
    }
</script>
